import { UseQueryResult, useQuery } from 'react-query'
import request from '../../../request'
import { useBuildQueryParams } from '../../../../lib/hooks/useBuildQueryParams'
import { useDealership } from '../../../../store/zustand/dealershipStore'

type ResultType = {
  metrics: Array<{
    date: Date
    clicks: number
    impressions: number
    ctr: number
    video_completions: number
    vtr: number
  }>
  overallMetrics: {
    impressions: number
    clicks: number
    video_completions: number
    first_quartile_completions: number
    second_quartile_completions: number
    third_quartile_completions: number
    vendor_id: number
    household_uniques: number
    household_frequency: number
    vtr: number
    video_starts: number
    reach: number
    frequency: number
  }
  geoInsightsCityData: Array<{
    location_name: string
    type: 'state' | 'city'
    audience_impressions: number
    impressions: number
  }>
}
export const useGetDSPReport = ({
  campaign_id,
  filters,
}: {
  campaign_id?: string | number
  filters?: Record<string, unknown>
}): UseQueryResult<ResultType, Error> => {
  const dealership = useDealership()
  const queryParams = useBuildQueryParams(filters)

  return useQuery<ResultType, Error>(
    ['campaigns', campaign_id, 'reports', 'dsp', { queryParams }],
    ({ signal }) =>
      request<{ data: ResultType }>({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/campaigns/display/dsp/${campaign_id}/metrics`,
        method: 'GET',
        signal,
        params: {
          ...queryParams,
        },
      }).then((res: { data: ResultType }) => res.data),
    {
      enabled: !!campaign_id,
      keepPreviousData: true,
    },
  )
}
